import React from 'react'
import './Header.css'
import useAuth from '../../hooks/useAuth'
import { Username } from '../Username'

export const Header: React.FC = () => {
  const { logout } = useAuth()

  return (
    <header className="topbar">
      <div className="flex items-center">
        <img src={`/logo-white.svg`} alt="ADSHINES logo" className="logo" />
      </div>
      <div className="user-info">
        <img src={'/icons/user.svg'} alt={'User Icon'} />
        <Username />
        <img
          src={`/icons/logout-64.png`}
          alt="logout"
          onClick={logout}
          className="logout-icon"
        ></img>
      </div>
    </header>
  )
}
